// export const metadata = {
//   title: 'Sign In - Mosaic',
//   description: 'Page description',
// }
"use client";

import Link from "next/link";
import AuthHeader from "../auth-header";
import AuthImage from "../auth-image";
import Input from "../../../components/Input";
import { FormEvent, useEffect, useState } from "react";
import Button from "../../../components/Button";
import { useUserStore } from "../../../stores/useUserStore";
import Banner from "@/src/components/banner";
import { useForm, FormProvider } from "react-hook-form";

export default function SignIn() {
  const [bannerErrorOpen, setBannerErrorOpen] = useState<boolean>(true);
  const { login, error, reset } = useUserStore();
  const methods = useForm();

  useEffect(() => {
    reset();
  }, []);

  const onSubmit = (data: any) => {
    setBannerErrorOpen(false);
    login(data);
    setBannerErrorOpen(true);
  };

  return (
    <main className="bg-white dark:bg-gray-900">
      <div className="relative md:flex">
        {/* Content */}
        <div className="md:w-1/2">
          <div className="min-h-[100dvh] h-full flex flex-col after:flex-1">
            <AuthHeader />
            <div className="max-w-sm mx-auto w-full px-4 py-8">
              {error?.message ? (
                <Banner
                  type="error"
                  open={bannerErrorOpen}
                  setOpen={setBannerErrorOpen}
                >
                  {error && error.message}
                </Banner>
              ) : null}
              <h1 className="text-3xl text-gray-800 dark:text-gray-100 font-bold mb-6">
                Welcome back!
              </h1>
              <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit)}>
                  <div className="space-y-4">
                    <div>
                      <Input
                        label={"Email Address"}
                        type="text"
                        name="email"
                        placeholder="name@mail.com"
                        required
                      />
                    </div>
                    <div>
                      <Input
                        label={"Password"}
                        type="password"
                        name="password"
                        placeholder="password"
                        required
                      />
                    </div>
                  </div>
                  <div className="flex items-center justify-between mt-6">
                    <div className="mr-1">
                      <Link
                        className="text-sm underline hover:no-underline"
                        href="/reset-password"
                      >
                        Forgot Password?
                      </Link>
                    </div>
                    <Button
                      type="submit"
                      className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white ml-3"
                    >
                      Sign In
                    </Button>
                  </div>
                </form>
              </FormProvider>
              {/* Footer */}
              <div className="pt-5 mt-6 border-t border-gray-100 dark:border-gray-700/60">
                <div className="text-sm">
                  Don't you have an account?{" "}
                  <Link
                    className="font-medium text-violet-500 hover:text-violet-600 dark:hover:text-violet-400"
                    href="/signup"
                  >
                    Sign Up
                  </Link>
                </div>
                {/* Warning */}
                {/* <div className="mt-5">
                  <div className="bg-yellow-500/20 text-yellow-700 px-3 py-2 rounded-lg">
                    <svg className="inline w-3 h-3 shrink-0 fill-current mr-2" viewBox="0 0 12 12">
                      <path d="M10.28 1.28L3.989 7.575 1.695 5.28A1 1 0 00.28 6.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 1.28z" />
                    </svg>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>

        <AuthImage />
      </div>
    </main>
  );
}
